export interface ToolDef {
  label: string;
  route: string;
  key: string;
  group: 'Core' | 'Inspect' | 'Crypto' | 'Utilities';
  execution: 'local' | 'hybrid';
  aliases?: string[];
}

export const TOOL_DEFS: ToolDef[] = [
  {
    key: 'inspect',
    label: 'Universal Inspector',
    route: '/inspect',
    group: 'Inspect',
    execution: 'local',
  },
  { key: 'diff', label: 'Diff Mode', route: '/tool/diff', group: 'Inspect', execution: 'local' },
  {
    key: 'cert',
    label: 'X.509 Inspector',
    route: '/tool/cert',
    group: 'Inspect',
    execution: 'local',
  },
  { key: 'query', label: 'JSON Query', route: '/tool/query', group: 'Inspect', execution: 'local' },
  {
    key: 'bytes',
    label: 'CBOR/MsgPack/PB',
    route: '/tool/bytes',
    group: 'Inspect',
    execution: 'local',
  },
  { key: 'pcap', label: 'PCAP-lite', route: '/tool/pcap', group: 'Inspect', execution: 'local' },
  { key: 'tls', label: 'TLS Verifier', route: '/tool/tls', group: 'Inspect', execution: 'local' },
  { key: 'asn1', label: 'ASN.1 / DER', route: '/tool/asn1', group: 'Inspect', execution: 'local' },
  {
    key: 'regex',
    label: 'Regex Extractor',
    route: '/tool/regex',
    group: 'Inspect',
    execution: 'local',
  },
  {
    key: 'schema',
    label: 'Schema Validators',
    route: '/tool/schema',
    group: 'Inspect',
    execution: 'local',
  },
  {
    key: 'dns',
    label: 'DNS Tools',
    route: '/tool/dns',
    group: 'Inspect',
    execution: 'hybrid',
    aliases: [
      'dns',
      'mx',
      'spf',
      'dmarc',
      'dkim',
      'a',
      'aaaa',
      'cname',
      'txt',
      'ns',
      'soa',
      'ptr',
      'reverse',
      'whois',
      'rdap',
      'arin',
      'asn',
      'mta-sts',
      'tlsrpt',
      'blacklist',
      'dnsbl',
      'domain health',
      'zone',
      'lookup',
    ],
  },
  { key: 'har', label: 'HAR Inspector', route: '/tool/har', group: 'Inspect', execution: 'local' },
  {
    key: 'cookies',
    label: 'Cookie Analyzer',
    route: '/tool/cookies',
    group: 'Inspect',
    execution: 'local',
  },
  {
    key: 'policy',
    label: 'Policy Linter',
    route: '/tool/policy',
    group: 'Inspect',
    execution: 'local',
  },
  { key: 'hex', label: 'Hex', route: '/tool/hex', group: 'Core', execution: 'local' },
  { key: 'base64', label: 'Base64', route: '/tool/base64', group: 'Core', execution: 'local' },
  { key: 'binary', label: 'Binary', route: '/tool/binary', group: 'Core', execution: 'local' },
  { key: 'url', label: 'URL', route: '/tool/url', group: 'Core', execution: 'local' },
  {
    key: 'compress',
    label: 'Compression',
    route: '/tool/compress',
    group: 'Core',
    execution: 'local',
  },
  {
    key: 'ascii',
    label: 'ASCII Art Generator',
    route: '/tool/ascii',
    group: 'Core',
    execution: 'local',
    aliases: ['ascii', 'text art', 'image to ascii', 'photo ascii'],
  },
  {
    key: 'batch',
    label: 'Batch Transform',
    route: '/tool/batch',
    group: 'Core',
    execution: 'local',
  },
  {
    key: 'format',
    label: 'Formatter Lab',
    route: '/tool/format',
    group: 'Core',
    execution: 'local',
    aliases: ['json', 'yaml', 'toml', 'xml', 'ini', 'env', 'sql', 'http', 'formatter', 'prettier'],
  },
  {
    key: 'timezone',
    label: 'Timezone Lab',
    route: '/tool/timezone',
    group: 'Core',
    execution: 'local',
  },
  { key: 'html', label: 'HTML Entities', route: '/tool/html', group: 'Core', execution: 'local' },
  { key: 'unicode', label: 'Unicode', route: '/tool/unicode', group: 'Core', execution: 'local' },
  { key: 'redact', label: 'Redaction', route: '/tool/redact', group: 'Core', execution: 'local' },
  { key: 'jwt', label: 'JWT Inspector', route: '/tool/jwt', group: 'Inspect', execution: 'local' },
  {
    key: 'hexdump',
    label: 'Hexdump',
    route: '/tool/hexdump',
    group: 'Inspect',
    execution: 'local',
  },
  { key: 'hash', label: 'Hash + HMAC', route: '/tool/hash', group: 'Crypto', execution: 'local' },
  {
    key: 'signer',
    label: 'HTTP Signer',
    route: '/tool/signer',
    group: 'Crypto',
    execution: 'local',
  },
  {
    key: 'webhook',
    label: 'Webhook Verifier',
    route: '/tool/webhook',
    group: 'Crypto',
    execution: 'local',
  },
  {
    key: 'replay',
    label: 'HTTP Replay',
    route: '/tool/replay',
    group: 'Crypto',
    execution: 'local',
  },
  {
    key: 'ids',
    label: 'UUID/ULID/KSUID',
    route: '/tool/ids',
    group: 'Utilities',
    execution: 'local',
  },
  {
    key: 'bitwise',
    label: 'Bitwise + Byte',
    route: '/tool/bitwise',
    group: 'Utilities',
    execution: 'local',
  },
];
